"use client";

import React, { FC, PropsWithChildren } from "react";
import {
  GlobalStateProvider,
  ShaApplicationProvider,
  AttachmentsEditorProvider,
  MainLayout,
  useNextRouter,
} from "@shesha-io/reactjs";
import { AppProgressBar } from "next-nprogress-bar";
import { useTheme } from "antd-style";
import { EnterpriseApplicationPlugin } from "@shesha-io/enterprise";
/* NEW_TOOLBOXCOMPONENT_IMPORT_GOES_HERE */
import { ContentApplicationPlugin } from '@shesha-io/content';

export interface IAppProviderProps {
  backendUrl: string;
}

export const AppProvider: FC<PropsWithChildren<IAppProviderProps>> = ({
  children,
  backendUrl,
}) => {
  const nextRouter = useNextRouter();
  const theme = useTheme();

  const noAuthRoutes = [
    "/no-auth",
    "/login",
    "/account/forgot-password",
    "/account/reset-password",
  ];
  const noAuth = Boolean(
    noAuthRoutes.find((r) => nextRouter.path?.includes(r))
  );

  // The Configuration Studio brings its own chrome and must render outside MainLayout.
  const withoutMainLayout = ["/configuration-studio"];
  const fullScreen = Boolean(
    withoutMainLayout.find((r) => nextRouter.path?.includes(r))
  );

  return (
    <GlobalStateProvider>
      <AppProgressBar height="4px" color={theme.colorPrimary} shallowRouting />
      <ShaApplicationProvider
        backendUrl={backendUrl}
        router={nextRouter}
        noAuth={false}
      >
        <EnterpriseApplicationPlugin>
          <ContentApplicationPlugin>
            <AttachmentsEditorProvider ownerId={""} ownerType={""}>
              {noAuth || fullScreen ? (
                <>{children}</>
              ) : (
                <MainLayout noPadding>{children}</MainLayout>
              )}
            </AttachmentsEditorProvider>
          </ContentApplicationPlugin>
        </EnterpriseApplicationPlugin>
      </ShaApplicationProvider>
    </GlobalStateProvider>
  );
};
